import { IIndividual, INationalId } from "@tfo/common/src/models/Interfaces"
import personnummer from 'personnummer.js'

const emptyNationalId: INationalId = { value: '', country: '' }

export const displayNationalId = (value: INationalId | IIndividual, masked: boolean = true) => {
    if(!value) {
        return ""
    }
    
    const nationalId: INationalId = 'nationalId' in value ? value.nationalId || emptyNationalId : value

    switch(nationalId.country) {
        case 'SE': return personnummer.normalise(nationalId.value, { normaliseFormat: masked ? 'YYYYMMDD-XXXX' : 'YYYYMMDD-NNNN'})
        default: return nationalId.value
    }
}